<div class="bg-hp-gradient-230 h-[6px]"></div>
<div class="flex justify-between pt-4 pr-4 pl-8">
  <hp-icons name="error"></hp-icons>
  <hp-icons class="cursor-pointer" mat-button mat-dialog-close [mat-dialog-close]="false" name="close-dialog"></hp-icons>
</div>
<div class="px-10 pt-4 pb-8">
  <h2>Error</h2>
  <p class=" text-[#68666F] text-[14px] font-normal leading-[24px]">{{data.message}}</p>
</div>